import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MessageService } from 'primeng/api';
import { ScholarshipService } from 'src/app/private/services/scholarship.service';
import { SharedModule } from 'src/app/private/shared/shared.module';
import { LocalStorageService } from 'src/app/utils/LocalStorageService';

@Component({
  selector: 'app-create-scholarship',
  imports: [SharedModule],
  templateUrl: './create-scholarship.component.html',
  styleUrl: './create-scholarship.component.scss'
})
export class CreateScholarshipComponent {

  @Input() type: string = 'Create';
  @Input() scholarshipData: any;
  @Output() closeDialog = new EventEmitter();
  @Output() reload = new EventEmitter();

  isSubmitted = false;
  btnLoading = false;

  scholarshipForm: FormGroup;

  statusOptions = ["Active", "Inactive"];
  typeOptions = ["Merit Based", "Need Based", "Sports", "Cultural", "Academic Excellence", "Financial Aid"];
  amountTypeOptions = ["Fixed", "Percentage"];
  currencyOptions = ["INR", "USD", "EUR"];

  constructor(
    private fb: FormBuilder,
    private messageService: MessageService,
    private api: ScholarshipService,
    private localStorage: LocalStorageService
  ) {
    this.scholarshipForm = this.fb.group({
      scholarship_code: ['', Validators.required],
      name: ['', Validators.required],
      description: [''],
      type: ['', Validators.required],
      eligibility_criteria: ['', Validators.required],
      amount_type: ['', Validators.required],
      amount_value: ['', [Validators.required, Validators.min(0)]],
      currency: ['INR', Validators.required],
      max_beneficiaries: ['', [Validators.required, Validators.min(1)]],
      start_date: ['', Validators.required],
      end_date: ['', Validators.required],
      renewable: [false],
      status: ['Active', Validators.required],
      organization_id: [this.localStorage.getOrganizationId() || ''],
      campus_id: [this.localStorage.getCampusId() || ''],
      created_by: [this.localStorage.getUserId() || 1],
      approved_by: [this.localStorage.getUserId() || 1]
    });
  }

  ngOnInit() {
    if (this.type === 'Update' && this.scholarshipData) {
      console.log('Updating scholarship with data:', this.scholarshipData);

      this.scholarshipForm.patchValue({
        scholarship_code: this.scholarshipData.scholarship_code,
        name: this.scholarshipData.name,
        description: this.scholarshipData.description,
        type: this.scholarshipData.type,
        eligibility_criteria: this.scholarshipData.eligibility_criteria,
        amount_type: this.scholarshipData.amount_type,
        amount_value: this.scholarshipData.amount_value,
        currency: this.scholarshipData.currency,
        max_beneficiaries: this.scholarshipData.max_beneficiaries,
        start_date: new Date(this.scholarshipData.start_date),
        end_date: new Date(this.scholarshipData.end_date),
        renewable: this.scholarshipData.renewable,
        status: this.scholarshipData.status,
        organization_id: this.scholarshipData.organization_id,
        campus_id: this.scholarshipData.campus_id,
        created_by: this.scholarshipData.created_by,
        approved_by: this.scholarshipData.approved_by
      });
    }
  }

  handleCloseDialog() {
    this.closeDialog.emit();
  }

  onSubmit() {
    this.isSubmitted = true;

    if (this.scholarshipForm.valid) {
      this.btnLoading = true;
      const payload = this.scholarshipForm.value;

      const apiCall = this.type === 'Create'
        ? this.api.createScholarship(payload)
        : this.api.updateScholarship({
          scholarship_id: this.scholarshipData.scholarship_id,
          ...payload
        });

      apiCall.subscribe({
        next: (res) => {
          this.messageService.add({ 
            severity: 'success', 
            summary: 'Success', 
            detail: `Scholarship ${this.type === 'Create' ? 'created' : 'updated'} successfully` 
          });
          this.scholarshipForm.reset();
          this.isSubmitted = false;
          this.reload.emit();
          this.handleCloseDialog();
          this.btnLoading = false;
        },
        error: (err) => {
          this.messageService.add({ 
            severity: 'error', 
            summary: 'Error', 
            detail: `Failed to ${this.type.toLowerCase()} scholarship` 
          });
          this.btnLoading = false;
        }
      });
    } else {
      this.messageService.add({ 
        severity: 'error', 
        summary: 'Validation Error', 
        detail: 'Please fill all required fields' 
      });
    }
  }
}